import PropTypes from "prop-types";
import { WebIcons } from "@/config/antd";
import "@/assets/styles/web_icons.css";
import { useTheme } from "@/hooks/ThemeContext";

const WebIcon = ({ icon, size = "default", className = "", onClick, color="" }) => {
  const { theme } = useTheme();
  const sizeClass =
    size === "small"
      ? "web-icon-small"
      : size === "large"
      ? "web-icon-large"
      : "web-icon";

  // Determine if this icon should be white in dark mode
  // Exclude: Hover icons, Blue icons, Notification icons, Cup, and social media icons
  const shouldBeWhiteInDarkMode =
    !icon.includes("Hover") &&
    !icon.startsWith("Blue") &&
    !icon.includes("Notification") &&
    icon !== "Cup" &&
    icon !== "Google" &&
    icon !== "Facebook";

  // Special handling for input focus states in dark mode
  const isBlackTextClass = className.includes("text-black");
  const isGrayTextClass = className.includes("text-gray-400");

  let iconStyle = {};


  if (color === "white") {
    iconStyle = { filter: "brightness(0) invert(1)" };
  } else if (color === "black") {
    iconStyle = { filter: "brightness(0) saturate(100%)" };
  }else if (theme === "dark" && isBlackTextClass && shouldBeWhiteInDarkMode) {
    // In dark mode, focused inputs should have white icons
    iconStyle = { filter: "brightness(0) invert(1)" };
  } else if (isBlackTextClass) {
    iconStyle = { filter: "brightness(0) saturate(100%)" };
  } else if (isGrayTextClass) {
    iconStyle = {
      filter:
        "brightness(0) saturate(100%) invert(42%) sepia(0%) saturate(0%) hue-rotate(134deg) brightness(95%) contrast(92%)",
    };
  } else if (theme === "dark" && shouldBeWhiteInDarkMode) {
    // Default dark mode behavior for other uses
    iconStyle = { filter: "brightness(0) invert(1)" };
  }

  return (
    <img
      src={WebIcons[icon]}
      alt={icon}
      className={`${sizeClass} ${className}`}
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        ...iconStyle,
      }}
    />
  );
};

WebIcon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.oneOf(["small", "default", "large"]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
};

export default WebIcon;
